import i18n from "i18next";
import Backend from "i18next-chained-backend";
import LocalStorageBackend from "i18next-localstorage-backend"; // primary use cache
import XHR from "i18next-xhr-backend"; // fallback xhr load
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import packageJson from "../package.json";
const ENV = process.env.REACT_APP_ENV || "des";
const version = ENV !== "pro" ? `${new Date().getTime()}` : packageJson.version;
i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: {
      "en-US": ["en"],
      "es-ES": ["es"],
      "es-MX": ["es"],
      default: ["es"],
    },
    debug: false,
    backend: {
      backends: [
        LocalStorageBackend, // primary
        XHR, // fallback
      ],
      backendOptions: [
        {
          prefix: "landing_page_translation_",
          // expiration
          expirationTime: 7 * 24 * 60 * 60 * 1000,

          // language versions
          versions: {
            en: version,
            es: version,
          },

          // can be either window.localStorage or window.sessionStorage. Default: window.localStorage
          store: window.localStorage,
        },
        {
          loadPath: process.env.PUBLIC_URL + "/locales/{{lng}}/{{ns}}.json", // xhr load path for my own fallback
          queryStringParams: { v: version },
        },
      ],
    },
  });

export default i18n;
